"use strict";
var import_vitest = require("vitest");
var import_createDevHandleRequest = require("./createDevHandleRequest");
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
import_vitest.vi.mock("./vite/getManifest", function() {
  return {
    getManifest: function() {
      return {
        pageRoutes: [
          {
            file: "app/index.tsx",
            page: "/",
            namedRegex: "^/(?:/)?$",
            routeKeys: {},
            type: "ssr",
            middlewares: []
          },
          {
            file: "app/(public)/otp+ssg.tsx",
            page: "/otp",
            namedRegex: "^/otp(?:/)?$",
            routeKeys: {},
            type: "ssg",
            middlewares: [],
            hasLoader: false
          },
          {
            file: "app/(public)/profile+ssg.tsx",
            page: "/profile",
            namedRegex: "^/profile(?:/)?$",
            routeKeys: {},
            type: "ssg",
            middlewares: [],
            hasLoader: true
          },
          {
            file: "app/[slug].tsx",
            page: "/[slug]",
            namedRegex: "^/(?<nxtPslug>[^/]+?)(?:/)?$",
            routeKeys: {
              nxtPslug: "slug"
            },
            type: "ssr",
            middlewares: []
          },
          {
            file: "app/+not-found.tsx",
            page: "/+not-found",
            namedRegex: "^/(?<nxtPnotfound>.+?)(?:/)?$",
            routeKeys: {
              nxtPnotfound: "not-found"
            },
            type: "spa",
            middlewares: []
          }
        ],
        apiRoutes: [
          {
            file: "app/api/github/agent/run.sh+api.ts",
            page: "/api/github/agent/run.sh",
            namedRegex: "^/api/github/agent/run\\.sh(?:/)?$",
            routeKeys: {},
            type: "api",
            middlewares: []
          }
        ]
      };
    }
  };
});
function createRequest(path) {
  var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GET";
  return new Request(`http://localhost:3000${path}`, {
    method,
    headers: {
      host: "localhost:3000"
    }
  });
}
(0, import_vitest.describe)("createHandleRequest", function() {
  var mockHandlers = {
    handlePage: import_vitest.vi.fn().mockResolvedValue("<html></html>")
  };
  (0, import_vitest.beforeEach)(function() {
    import_vitest.vi.clearAllMocks();
  });
  (0, import_vitest.describe)("static file extension filtering", function() {
    (0, import_vitest.it)("should skip paths with file extensions (favicon.ico)", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/favicon.ico"));
      (0, import_vitest.expect)(result).toBeNull();
      (0, import_vitest.expect)(mockHandlers.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("should skip paths with file extensions (logo.png)", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/logo.png"));
      (0, import_vitest.expect)(result).toBeNull();
      (0, import_vitest.expect)(mockHandlers.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("should skip paths with file extensions (styles.css)", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/styles.css"));
      (0, import_vitest.expect)(result).toBeNull();
      (0, import_vitest.expect)(mockHandlers.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("should skip paths with file extensions (robots.txt)", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/robots.txt"));
      (0, import_vitest.expect)(result).toBeNull();
      (0, import_vitest.expect)(mockHandlers.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("should skip nested paths with file extensions", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/assets/images/logo.png"));
      (0, import_vitest.expect)(result).toBeNull();
      (0, import_vitest.expect)(mockHandlers.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("should skip extensions 2-4 chars like .xyz", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/somefile.xyz"));
      (0, import_vitest.expect)(result).toBeNull();
      (0, import_vitest.expect)(mockHandlers.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("should skip common static extensions longer than 4 chars", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/font.woff2"));
      (0, import_vitest.expect)(result).toBeNull();
      (0, import_vitest.expect)(mockHandlers.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("should not render a user +not-found page for sourcemap requests", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/deps-web/react-BwkDMLyL.js.map"));
      (0, import_vitest.expect)(result).toBeNull();
      (0, import_vitest.expect)(mockHandlers.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("should still route static-looking API paths", async function() {
      var mockHandlersWithAPI = {
        handlePage: import_vitest.vi.fn().mockResolvedValue("<html></html>"),
        handleAPI: import_vitest.vi.fn().mockResolvedValue({
          GET: function() {
            return new Response("script");
          }
        })
      };
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlersWithAPI, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/api/github/agent/run.sh"));
      (0, import_vitest.expect)(result).not.toBeNull();
      (0, import_vitest.expect)(await result.text()).toBe("script");
      (0, import_vitest.expect)(mockHandlersWithAPI.handleAPI).toHaveBeenCalled();
      (0, import_vitest.expect)(mockHandlersWithAPI.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("should not skip non-static extensions in route names", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      await handler(createRequest("/route.normal"));
      (0, import_vitest.expect)(mockHandlers.handlePage).toHaveBeenCalled();
    });
    (0, import_vitest.it)("should NOT skip loader paths ending with _vxrn_loader.js", async function() {
      var mockHandlersWithLoader = {
        handlePage: import_vitest.vi.fn().mockResolvedValue("<html></html>"),
        handleLoader: import_vitest.vi.fn().mockResolvedValue("loader data")
      };
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlersWithLoader, {
        routerRoot: "/app"
      });
      await handler(createRequest("/assets/my-page_123_vxrn_loader.js"));
      (0, import_vitest.expect)(mockHandlersWithLoader.handleLoader).toHaveBeenCalled();
    });
  });
  (0, import_vitest.describe)("loader dispatch short-circuit for no-loader routes", function() {
    (0, import_vitest.it)("should return empty loader module without calling handleLoader when route has hasLoader: false", async function() {
      var mockHandlersWithLoader = {
        handlePage: import_vitest.vi.fn().mockResolvedValue("<html></html>"),
        handleLoader: import_vitest.vi.fn().mockResolvedValue("loader data")
      };
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlersWithLoader, {
        routerRoot: "/app"
      });
      var response = await handler(createRequest("/assets/otp_123_vxrn_loader.js"));
      (0, import_vitest.expect)(mockHandlersWithLoader.handleLoader).not.toHaveBeenCalled();
      (0, import_vitest.expect)(response).not.toBeNull();
      (0, import_vitest.expect)(response.status).toBe(200);
      (0, import_vitest.expect)(response.headers.get("Content-Type")).toBe("text/javascript");
      var body = await response.text();
      (0, import_vitest.expect)(body).toContain("export function loader()");
      (0, import_vitest.expect)(body).toContain("return undefined");
    });
    (0, import_vitest.it)("should still call handleLoader when route has hasLoader: true", async function() {
      var mockHandlersWithLoader = {
        handlePage: import_vitest.vi.fn().mockResolvedValue("<html></html>"),
        handleLoader: import_vitest.vi.fn().mockResolvedValue("export function loader(){return 1}")
      };
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlersWithLoader, {
        routerRoot: "/app"
      });
      await handler(createRequest("/assets/profile_123_vxrn_loader.js"));
      (0, import_vitest.expect)(mockHandlersWithLoader.handleLoader).toHaveBeenCalled();
    });
    (0, import_vitest.it)("should still call handleLoader when hasLoader is undefined (dev/back-compat)", async function() {
      var mockHandlersWithLoader = {
        handlePage: import_vitest.vi.fn().mockResolvedValue("<html></html>"),
        handleLoader: import_vitest.vi.fn().mockResolvedValue("loader data")
      };
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlersWithLoader, {
        routerRoot: "/app"
      });
      await handler(createRequest("/assets/my-page_123_vxrn_loader.js"));
      (0, import_vitest.expect)(mockHandlersWithLoader.handleLoader).toHaveBeenCalled();
    });
  });
  (0, import_vitest.describe)("dynamic route matching", function() {
    (0, import_vitest.it)("should match dynamic routes for regular paths without extensions", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      await handler(createRequest("/my-page"));
      (0, import_vitest.expect)(mockHandlers.handlePage).toHaveBeenCalled();
    });
    (0, import_vitest.it)("should match index route", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      await handler(createRequest("/"));
      (0, import_vitest.expect)(mockHandlers.handlePage).toHaveBeenCalled();
    });
    (0, import_vitest.it)("should match paths with hyphens", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      await handler(createRequest("/my-awesome-page"));
      (0, import_vitest.expect)(mockHandlers.handlePage).toHaveBeenCalled();
    });
  });
  (0, import_vitest.describe)("request method dispatch", function() {
    (0, import_vitest.it)("answers HEAD page requests exactly like GET", async function() {
      var handlePage = import_vitest.vi.fn(async function() {
        return new Response("<html></html>", {
          headers: {
            "content-type": "text/html"
          }
        });
      });
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)({
        handlePage
      }, {
        routerRoot: "/app"
      });
      var get = await handler(createRequest("/my-page", "GET"));
      var head = await handler(createRequest("/my-page", "HEAD"));
      if (!_instanceof(get, Response) || !_instanceof(head, Response)) {
        throw new Error("expected both GET and HEAD to return a Response");
      }
      (0, import_vitest.expect)(head.status).toBe(get.status);
      (0, import_vitest.expect)(head.headers.get("content-type")).toBe(get.headers.get("content-type"));
      (0, import_vitest.expect)(handlePage).toHaveBeenCalledTimes(2);
    });
    (0, import_vitest.it)("continues routing HEAD requests to API handlers", async function() {
      var mockHandlersWithAPI = {
        handlePage: import_vitest.vi.fn().mockResolvedValue("<html></html>"),
        handleAPI: import_vitest.vi.fn().mockResolvedValue({
          HEAD: function() {
            return new Response(null, {
              status: 204
            });
          }
        })
      };
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlersWithAPI, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/api/github/agent/run.sh", "HEAD"));
      (0, import_vitest.expect)(result).toBeInstanceOf(Response);
      if (!_instanceof(result, Response)) {
        throw new Error("expected HEAD API request to return a Response");
      }
      (0, import_vitest.expect)(result.status).toBe(204);
      (0, import_vitest.expect)(mockHandlersWithAPI.handleAPI).toHaveBeenCalledOnce();
      (0, import_vitest.expect)(mockHandlersWithAPI.handlePage).not.toHaveBeenCalled();
    });
    (0, import_vitest.it)("does not route POST requests to page handlers", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/my-page", "POST"));
      (0, import_vitest.expect)(result).toBeNull();
      (0, import_vitest.expect)(mockHandlers.handlePage).not.toHaveBeenCalled();
    });
  });
  (0, import_vitest.describe)("special paths", function() {
    (0, import_vitest.it)("should skip __vxrnhmr path", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var result = await handler(createRequest("/__vxrnhmr"));
      (0, import_vitest.expect)(result).toBeNull();
    });
    (0, import_vitest.it)("should skip vite internal paths like /@fs/", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      (0, import_vitest.expect)(await handler(createRequest("/@fs/some/path"))).toBeNull();
      (0, import_vitest.expect)(await handler(createRequest("/@vite/client"))).toBeNull();
      (0, import_vitest.expect)(await handler(createRequest("/@id/__x00__virtual:one-entry"))).toBeNull();
    });
    (0, import_vitest.it)("should NOT skip user routes that start with @", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      await handler(createRequest("/@admin"));
      (0, import_vitest.expect)(mockHandlers.handlePage).toHaveBeenCalled();
    });
  });
  (0, import_vitest.describe)("requests without a Host header", function() {
    (0, import_vitest.it)("resolves an absolute request URL with no Host header", async function() {
      var { handler } = (0, import_createDevHandleRequest.createHandleRequest)(mockHandlers, {
        routerRoot: "/app"
      });
      var request = new Request("http://localhost:3000/some-page");
      (0, import_vitest.expect)(request.headers.get("host")).toBeNull();
      await (0, import_vitest.expect)(handler(request)).resolves.not.toThrow();
      (0, import_vitest.expect)(mockHandlers.handlePage).toHaveBeenCalled();
    });
  });
});
//# sourceMappingURL=createHandleRequest.test.js.map
